import { t as T } from "./dist-CRiumotD.js";
import { n as cx } from "./primitives-DLlUP8hy.js";
import { jsx } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { FieldError, Label, Text } from "react-aria-components";
const labelStyles = T({ base: "select-none text-base/6 text-fg in-disabled:opacity-50 group-disabled:opacity-50 sm:text-sm/6" }), descriptionStyles = T({ base: "block text-muted-fg text-sm/6 in-disabled:opacity-50 group-disabled:opacity-50" }), fieldErrorStyles = T({ base: "block text-danger-subtle-fg text-sm/6 in-disabled:opacity-50 group-disabled:opacity-50 forced-colors:text-[Mark]" }), fieldStyles = T({ base: [
	"w-full",
	"[&>[data-slot=label]+[data-slot=control]]:mt-2",
	"[&>[data-slot=label]+[data-slot=control]]:mt-2",
	"[&>[data-slot=label]+[slot='description']]:mt-1",
	"[&>[slot='description']+[data-slot=control]]:mt-2",
	"[&>[data-slot=control]+[slot=description]]:mt-2",
	"[&>[data-slot=control]+[slot=errorMessage]]:mt-2",
	"*:data-[slot=label]:font-medium",
	"in-disabled:opacity-50 disabled:opacity-50"
] });
function Label$1({ className: e,...h }) {
	return /* @__PURE__ */ jsx(Label, {
		"data-slot": "label",
		...h,
		className: labelStyles({ className: e })
	});
}
function Description({ className: e,...h }) {
	return /* @__PURE__ */ jsx(Text, {
		...h,
		slot: "description",
		className: descriptionStyles({ className: e })
	});
}
function Fieldset({ className: e,...h }) {
	return /* @__PURE__ */ jsx("fieldset", {
		className: twMerge("*:data-[slot=text]:mt-1 [&>*+[data-slot=control]]:mt-6", e),
		...h
	});
}
function FieldGroup({ className: e,...h }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "control",
		className: twMerge("space-y-6", e),
		...h
	});
}
function FieldError$1({ className: e,...g }) {
	return /* @__PURE__ */ jsx(FieldError, {
		...g,
		className: cx(fieldErrorStyles(), e)
	});
}
function Legend({ className: e,...h }) {
	return /* @__PURE__ */ jsx("legend", {
		"data-slot": "legend",
		...h,
		className: twMerge("font-semibold text-base/6 data-disabled:opacity-50", e)
	});
}
export { Label$1 as a, fieldErrorStyles as c, Fieldset as i, fieldStyles as l, FieldError$1 as n, Legend as o, FieldGroup as r, descriptionStyles as s, Description as t, labelStyles as u };
